import React, { useState } from 'react';
import _ from 'lodash';
import { Button, Snackbar, TextField, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CustomAxios from '../utility/customAxios';
import { externalFormStyling } from '../styles/sxStyling';

export default function ForgotPassword() {
  const [email, setEmail] = useState<string>('');
  const [sent, setSent] = useState<boolean>(false);

  const onSend = async () => {
    await CustomAxios.post('password/request-reset', { email });
    setSent(true);
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '70vh',
        }}
      >
        <Typography variant="h5">
          Forgot Password
        </Typography>
        <Box sx={externalFormStyling}>
          <Typography>Please enter your email</Typography>
          <TextField required label="Email Address" autoComplete="email" autoFocus value={email} onChange={event => setEmail(event.target.value)} />
          <Button fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} onClick={onSend} disabled={_.isEmpty(email)}>
            Send Reset Email
          </Button>
        </Box>
      </Box>
      <Snackbar open={sent} onClose={() => setSent(false)} message="Reset Email Sent!" />
    </Container>
  );
}